import type { ReactNode } from 'react';

import { FeatureFlag } from '@revelio/core';
import { AdminIdProvider } from '@revelio/ui';

import { useUnleashFlag } from '../unleash-flags/use-unleash-flag';

/**
 * Reads the selection-list id flag once for the whole app. `@revelio/ui` owns
 * the reveal behaviour but cannot read flags, so this is the seam between them.
 * Mounted inside `UnleashFlags`, which is where flag values become available.
 */
export const SelectionListIdsProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const isSelectionListIdsEnabled = useUnleashFlag(
    FeatureFlag.SelectionListIds
  );

  return (
    <AdminIdProvider enabled={isSelectionListIdsEnabled}>
      {children}
    </AdminIdProvider>
  );
};
